/*
 * @Author: edvardchen
 * @Date:   2016-07-15 09:37:03
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2021-02-26 10:05:52
 */
import React from 'react';
import PropTypes from 'prop-types';
import qblogin from '@tencent/qblogin';
import { makeauthenticate } from '../ducks/login';
import { connect } from 'react-redux';

class App extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    qblogin.initSession({
      isDebug: true,
      sessionObserver: async (session) => {
        dispatch(makeauthenticate(session));
      },
    });
  }

  render() {
    return this.props.children;
  }
}

export default connect()(App);
